export default "__VITE_ASSET__C9Icq4ya__"